import React, { Component } from "react";
// import PropTypes from "prop-types";
import DOMPurify from "dompurify";
import {
  Box,
  Button,
  Grid,
  List,
  ListItem,
  Typography
} from "@material-ui/core";
import moment from "moment";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Code, Collections, PictureAsPdf } from "@material-ui/icons";
import withTheme from "@material-ui/core/styles/withTheme";
import UserService from "../services/UserService";
import Dialog from "../waybee-ui/Dialog";

const EventText = styled(Typography)`
  font-weight: bold;
  color: ${({ color }) => color};
`;

const BodyMessage = styled.div`
  margin: 0;
  max-width: 100%;

  p {
    margin: 0;
    font-size: 16px;
    color: ${({ color }) => color};
  }

  img {
    width: 100%;
  }
`;

const AckButton = styled(Button)`
  color: ${({ color }) => color};
  background-color: ${({ bgColor }) => bgColor};
`;

class AckDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      dateEvent: moment(props.pendingCommunication.eventStart).format(
        "DD/MM/YYYY"
      ),
      hourEvent: moment(props.pendingCommunication.eventStart).format("HH:mm"),
      hasAck: false,
      pendingCommunication: props.pendingCommunication,
      communicationAttachment: props.communicationAtt
    };
  }

  changeAck = async (event, communication) => {
    const { onChangeAck } = this.props;
    await UserService.updateAckCommunication(
      true,
      communication.id,
      communication.userId
    );
    onChangeAck();
    this.setState({ hasAck: true, open: false });
  };

  clickAttachment = attachment => {
    if (attachment.url !== null && attachment.url !== "") {
      window.open(attachment.url, "_system");
    }
  };

  onClose = () => {
    const { hasAck } = this.state;
    if (!hasAck) {
      alert("Você precisa dar ciência no aviso para prosseguir");
    } else {
      this.setState({ open: false });
    }
  };

  render() {
    const {
      open,
      dateEvent,
      hourEvent,
      pendingCommunication,
      communicationAttachment
    } = this.state;
    const { theme } = this.props;

    return (
      <Dialog open={open} onClose={this.onClose} maxWidth="sm" fullWidth>
        <Box p={3}>
          <Typography variant="h2">{pendingCommunication.title}</Typography>
          <Typography variant="subtitle1">
            {moment(pendingCommunication.createdAt).format("DD/MM/YYYY")}
          </Typography>
          <Box mt={4}>
            {pendingCommunication.type === 2 && (
              <EventText color={theme.palette.secondary.dark}>
                {`Evento: ${dateEvent} às ${hourEvent}`}
              </EventText>
            )}
            <BodyMessage
              color={theme.palette.default.light}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(pendingCommunication.bodyMessage)
              }}
            />
            {communicationAttachment &&
              communicationAttachment.lenght > 0 &&
              communicationAttachment.map(
                attachment =>
                  pendingCommunication.id === attachment.communicationId && (
                    <List
                      key={pendingCommunication.id}
                      onClick={() => this.clickAttachment(attachment)}
                    >
                      {attachment.type === "application/pdf" && (
                        <ListItem
                          primaryText={attachment.customName}
                          leftIcon={<PictureAsPdf />}
                        />
                      )}
                      {(attachment.type === "image/png" ||
                        attachment.type === "image/jpeg") && (
                        <ListItem
                          primaryText={attachment.customName}
                          leftIcon={<Collections />}
                        />
                      )}
                      {attachment.type === "text/html" && (
                        <ListItem
                          primaryText={attachment.customName}
                          leftIcon={<Code />}
                        />
                      )}
                    </List>
                  )
              )}
          </Box>
          <Grid container justify="flex-end" xs={12}>
            <AckButton
              variant="contained"
              bgColor={theme.palette.primary.main}
              color={theme.palette.default.contrastText}
              onClick={e => this.changeAck(e, pendingCommunication)}
            >
              Estou ciente
            </AckButton>
          </Grid>
        </Box>
      </Dialog>
    );
  }
}

AckDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  pendingCommunication: PropTypes.arrayOf().isRequired,
  communicationAtt: PropTypes.arrayOf().isRequired,
  theme: PropTypes.objectOf().isRequired,
  onChangeAck: PropTypes.func.isRequired
};

export default withTheme(AckDialog);
